import * as React from "react";
import MuiDialogContent, {
    DialogContentProps as MuiDialogContentProps,
    DialogContentClassKey as MuiDialogContentClassKey
} from "@material-ui/core/DialogContent";

export type DialogContentClassKey = MuiDialogContentClassKey;

export interface DialogContentProps extends MuiDialogContentProps { }

class DialogContent extends React.PureComponent<DialogContentProps> {
    render() {
        const { ...props } = this.props;
        return <MuiDialogContent {...props}>
            {this.props.children}
        </MuiDialogContent>;
    }
}

export default DialogContent